export const defaultLanguage = "en";
export const fallbackLanguage = "en";
